export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7240.7eb6c7be.jpg";